/**
 * Candidacies Kanban Configuration
 * 
 * Configuration for the Candidacies kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { Application } from 'screens/candidacies/candidacies';
import { candidacyPhaseColumns, type CandidacyStatus } from 'screens/candidacies/candidacyPhaseConfig';

const candidacyColumnTooltips: Partial<Record<CandidacyStatus, string>> = {
  notify: 'Plan de eerste uitnodiging voor de kandidaat en controleer de gegevens die meegestuurd moeten worden.',
  invited: 'Uitnodiging verstuurd. Wacht op reactie van de kandidaat en stuur eventueel een herinnering.',
  'awaiting-visit': 'Bezoek ingepland. Vergeet niet om praktische info en opvolging te voorzien.',
  'awaiting-interested': 'Wacht op de bevestiging na het bezoek. Noteer reacties in de kandidaatfiche.',
  interested: 'Kandidaat wil huren. Verzamel ontbrekende documenten en start het screeningsproces.',
  approved: 'Alles in orde. Rond de contractvoorbereiding af en plan de ondertekening.',
  tenant: 'Kandidaat is intussen huurder. Zorg dat dossiers en communicatie aligneren met de huurdossiers.',
  rejected: 'Kandidaat afgewezen. Leg kort vast waarom zodat we later kunnen rapporteren.',
  'not-interested': 'Kandidaat heeft afgehaakt. Rond lopende communicatie af en markeer het dossier als afgerond.',
};

/**
 * Candidacies Kanban Configuration
 * 
 * This config defines how the Candidacies kanban should look and behave:
 * - Uses phase columns from candidacyPhaseConfig (single source of truth)
 * - Shows count per column
 * - Non-scrollable columns (full height)
 * - Grid layout automatically adapts to number of columns (9 statuses)
 */
export const candidaciesKanbanConfig: KanbanConfig<Application, CandidacyStatus> = {
  // Column definitions from existing candidacyPhaseConfig
  columns: candidacyPhaseColumns.map((column) => ({
    ...column,
    tooltip: candidacyColumnTooltips[column.id],
  })),
  
  // Get the status for a candidacy
  getItemStatus: (candidacy: Application) => candidacy.status as CandidacyStatus,
  
  // Show count badge per column
  showCount: true,
  
  // No add button for candidacies
  showAddButton: false,
  
  // Empty state configuration
  emptyState: {
    message: 'Geen kandidaten',
  },
  
  // Columns are scrollable with sticky headers for long lists
  scrollableColumns: true,

  // Enable explanatory tooltips per column
  tooltips: true,
};

